<template>
  <section class="dp-layout screen-device-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>
    <section class="dp-right">
      <div v-if="!schoolId" class="no-data-tip">
        <i class="el-icon-school"></i>
        <p>请从左侧选择学校后再发布大屏配置</p>
      </div>
      <div v-else class="content-wrapper config-panel">
        <el-card class="config-card">
          <div slot="header" class="card-header">
            <div class="title-wrap">
              <span class="title">大屏配置发布</span>
              <span v-if="schoolName" class="school-tag">当前学校：{{ schoolName }}</span>
            </div>
            <div class="actions">
              <el-button type="primary" size="small" @click="publishConfig">发布配置</el-button>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="110px"
            :label-position="publishFormLabelPosition"
            class="publish-form"
          >
            <el-form-item label="设备 SN" required>
              <el-select v-model="form.Sn" filterable placeholder="请选择SN" @change="loadRuntimeConfig" style="width: 100%">
                <el-option v-for="item in snOptions" :key="item.Sn" :label="`${item.Sn} - ${item.DeviceName || ''}`" :value="item.Sn" />
              </el-select>
            </el-form-item>
            <el-form-item label="是否启用">
              <el-switch v-model="isDisplaying" active-text="启用" inactive-text="禁用" />
            </el-form-item>
            <el-form-item label="地址类型" required>
              <el-select
                v-model="selectedScreenType"
                filterable
                clearable
                placeholder="请选择大屏类型"
                style="width: 100%"
                @change="handleScreenTypeChange"
              >
                <el-option
                  v-for="item in screenTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="screen-type-option">
                    <i :class="item.icon" :style="{ color: item.color || '#909399' }"></i>
                    <span>{{ item.label }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isHomeworkType" label="选择班级">
              <el-select
                v-model="selectedClassId"
                filterable
                clearable
                placeholder="请选择作业公示班级"
                style="width: 100%"
                @change="updateHomeworkUrl"
              >
                <el-option
                  v-for="item in classOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="isDormType" label="选择楼栋">
              <el-select
                v-model="selectedBuildingId"
                filterable
                clearable
                placeholder="可不选：默认首栋，页内可切换"
                style="width: 100%"
                @change="updateDormUrl"
              >
                <el-option
                  v-for="item in dormBuildings"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="大屏地址" :required="isDisplaying">
              <div class="screen-url-display">
                <div class="url-text-wrap">
                  <i class="el-icon-link url-icon"></i>
                  <span class="url-text">{{ form.ScreenUrl || "选择地址类型后自动生成" }}</span>
                </div>
                <div class="url-actions">
                  <el-button size="mini" @click="previewUrl(form.ScreenUrl)" :disabled="!form.ScreenUrl">预览</el-button>
                  <el-button size="mini" @click="copyUrl(form.ScreenUrl)" :disabled="!form.ScreenUrl">复制</el-button>
                </div>
              </div>
            </el-form-item>
            <!--
            <el-form-item label="大屏地址">
              <el-select
                v-model="form.ScreenUrl"
                filterable
                clearable
                placeholder="请选择大屏汇总中的地址"
                style="width: 100%"
              >
                <el-option-group
                  v-for="group in screenUrlGroups"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-option-group>
              </el-select>
            </el-form-item>
            -->
            <el-form-item label="展示时长(秒)">
              <el-input-number v-model="form.DurationSec" :min="0" />
              <span style="margin-left: 8px; color: #909399">0 表示不限时</span>
              <el-tooltip
                effect="dark"
                content="预留参数：当前后端仅记录与下发，不做自动定时关闭。"
                placement="top"
              >
                <i class="el-icon-question duration-help-icon"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="config-card" style="margin-top: 10px">
          <div slot="header" class="card-header">
            <div class="title-wrap">
              <span class="title">当前生效配置</span>
              <el-tag v-if="showUnpublishedTag" size="mini" type="warning" effect="plain" style="margin-left: 10px;">未发布</el-tag>
            </div>
            <div class="actions">
              <el-button
                v-if="showToggleButton"
                :type="toggleButtonType"
                size="small"
                plain
                @click="toggleRuntimeStatus"
              >
                {{ toggleButtonText }}
              </el-button>
            </div>
          </div>
          <el-descriptions :column="runtimeDescriptionsColumn" border class="runtime-descriptions">
            <el-descriptions-item label="SN">{{ runtime.Sn || "-" }}</el-descriptions-item>
            <el-descriptions-item label="版本号">{{ runtime.ConfigVersion || "-" }}</el-descriptions-item>
            <el-descriptions-item label="启用状态">{{ getDisplayStateText(runtime.DisplayState) }}</el-descriptions-item>
            <el-descriptions-item label="展示时长">{{ getDurationText(runtime.DurationSec) }}</el-descriptions-item>
            <el-descriptions-item label="地址" :span="runtimeUrlSpan">
              <span class="runtime-url-text">{{ runtime.ScreenUrl || "-" }}</span>
            </el-descriptions-item>
          </el-descriptions>
          <div class="duration-reserve-tip runtime-tip">
            <i class="el-icon-info"></i>
            <span>展示时长为预留参数，当前用于记录与下发显示。</span>
          </div>
        </el-card>
      </div>
    </section>
  </section>
</template>

<script>
import { getScreenDeviceList } from '../../api/modules/integration';
import { publishScreenConfigAdmin, getScreenRuntimeConfigAdmin } from '../../api/modules/misc';
import { getSubDepartmentTree } from '../../api/modules/department';
import { getBuildingsListPage } from '../../api/modules/dormitory';
import { getScreenList, parseScreenListResponse } from "@/api/dismissal";
import DepartmentPane from "@/components/DepartmentPane.vue";

export default {
  name: "ScreenDeviceManageConfigPublish",
  components: { DepartmentPane },
  data() {
    return {
      schoolId: 0,
      schoolName: "",
      baseUrl: window.location.origin,
      snOptions: [],
      screenTypeOptions: [],
      selectedScreenType: "",
      selectedClassId: "",
      selectedBuildingId: "",
      classOptions: [],
      dormBuildings: [],
      staticScreens: [
        { name: "考勤大屏", path: "/AttenBigScreen", param: "departmentId", icon: "el-icon-time", color: "#2563eb", value: "atten" },
        { name: "宿舍大屏", path: "/static/dorm-screen/index.html", param: "departmentId", icon: "el-icon-house", color: "#67C23A", value: "dorm" },
        { name: "请假大屏", path: "/LeaveBigScreen", param: "departmentId", icon: "el-icon-suitcase", color: "#E6A23C", value: "leave" },
        { name: "离校大屏", path: "/LeaveOutBigScreen", param: "departmentId", icon: "el-icon-circle-close", color: "#F56C6C", value: "leaveOut" },
        { name: "学校大屏", path: "/SchoolInfoScreen", param: "departmentId", icon: "el-icon-school", color: "#909399", value: "schoolInfo" },
        { name: "德育大屏", path: "/MoralEducationBigScreen", param: "departmentId", icon: "el-icon-medal", color: "#00bcd4", value: "moralEducation" },
        { name: "积分大屏", path: "/MoralPointBigScreen", param: "departmentId", icon: "el-icon-coin", color: "#ffb347", value: "moralPoint" },
        { name: "哲商五育大屏", path: "/ZheshangFiveEducationScreen", param: "departmentId", icon: "el-icon-data-analysis", color: "#7c3aed", value: "zheshangFiveEducation" },
        { name: "哲商学生画像", path: "/ZheshangStudentPortraitScreen", param: "departmentId", icon: "el-icon-user", color: "#ec4899", value: "zheshangStudentPortrait" }
      ],
      form: {
        Sn: "",
        ScreenUrl: "",
        DisplayState: "playing",
        DurationSec: 0,
        ExtraJson: ""
      },
      runtime: {},
      runtimeLoading: false,
      /** 用于窄屏下 descriptions 列数、表单项排布 */
      layoutViewportWidth: typeof window !== "undefined" ? window.innerWidth : 1200
    };
  },
  computed: {
    hasRuntimeConfig() {
      return !!(this.runtime && this.runtime.Sn && Number(this.runtime.ConfigVersion || 0) > 0);
    },
    showUnpublishedTag() {
      return !!this.form.Sn && !this.runtimeLoading && !this.hasRuntimeConfig;
    },
    showToggleButton() {
      return !!this.form.Sn && this.hasRuntimeConfig;
    },
    runtimeIsEnabled() {
      return this.hasRuntimeConfig && this.runtime.DisplayState === "playing";
    },
    toggleButtonText() {
      return this.runtimeIsEnabled ? "禁用" : "启用";
    },
    toggleButtonType() {
      return this.runtimeIsEnabled ? "danger" : "success";
    },
    isHomeworkType() {
      return this.selectedScreenType === "homework";
    },
    isDormType() {
      return this.selectedScreenType === "dorm";
    },
    isDisplaying: {
      get() {
        return this.form.DisplayState === "playing";
      },
      set(value) {
        this.form.DisplayState = value ? "playing" : "closed";
      }
    },
    /** 窄屏：标签置顶，避免标签+控件挤出可视区 */
    publishFormLabelPosition() {
      return this.layoutViewportWidth <= 720 ? "top" : "right";
    },
    /** 当前生效配置：窄屏单列更易读 */
    runtimeDescriptionsColumn() {
      return this.layoutViewportWidth <= 720 ? 1 : 2;
    },
    runtimeUrlSpan() {
      return this.runtimeDescriptionsColumn === 1 ? 1 : 2;
    }
  },
  mounted() {
    this.loadSnOptions();
    this._onLayoutResize = this.debounceLayoutResize(() => {
      this.layoutViewportWidth = window.innerWidth;
    }, 120);
    window.addEventListener("resize", this._onLayoutResize, { passive: true });
  },
  beforeDestroy() {
    if (this._onLayoutResize) {
      window.removeEventListener("resize", this._onLayoutResize);
    }
  },
  methods: {
    debounceLayoutResize(fn, delay) {
      let timer = null;
      return function wrapped() {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          timer = null;
          fn();
        }, delay);
      };
    },
    treeNodeClick(node) {
      this.schoolId = Number(node && node.value ? node.value : 0);
      this.schoolName = node && node.label ? node.label : "";
      this.form.Sn = "";
      this.form.ScreenUrl = "";
      this.selectedScreenType = "";
      this.selectedClassId = "";
      this.selectedBuildingId = "";
      this.dormBuildings = [];
      this.runtime = {};
      this.loadSnOptions();
      this.loadScreenUrlOptions();
      this.loadDormBuildings();
    },
    async loadSnOptions() {
      if (!this.schoolId) {
        this.snOptions = [];
        return;
      }
      const res = await getScreenDeviceList({ schoolId: this.schoolId });
      if (res.data.success) {
        const pageResult = res.data.response || {};
        this.snOptions = pageResult.data || [];
      }
    },
    async loadRuntimeConfig() {
      if (!this.form.Sn) {
        this.runtime = {};
        return;
      }
      const targetSn = (this.form.Sn || "").trim();
      const currentRuntimeSn = this.runtime && this.runtime.Sn ? String(this.runtime.Sn).trim() : "";
      if (targetSn && currentRuntimeSn && targetSn !== currentRuntimeSn) {
        this.runtime = {};
        this.form.ScreenUrl = "";
        this.selectedScreenType = "";
        this.selectedClassId = "";
        this.selectedBuildingId = "";
      }
      this.runtimeLoading = true;
      try {
        const res = await getScreenRuntimeConfigAdmin({ sn: targetSn });
        if (res.data.success) {
          this.runtime = res.data.response || {};
          this.form.ScreenUrl = this.runtime.ScreenUrl || this.form.ScreenUrl;
          this.syncSelectionByUrl(this.form.ScreenUrl);
        } else {
          this.runtime = {};
        }
      } finally {
        this.runtimeLoading = false;
      }
    },
    async loadScreenUrlOptions() {
      if (!this.schoolId) {
        this.screenTypeOptions = [];
        this.classOptions = [];
        return;
      }

      const options = [];
      const uiBase = ((process.env.BASE_URL || "/").replace(/\/+$/, "") || "");
      const api = (process.env.VUE_APP_BASE_API || "").replace(/\/+$/, "");
      this.staticScreens.forEach((item) => {
        let url = `${this.baseUrl}${uiBase}${item.path}?${item.param}=${this.schoolId}`;
        if (item.value === "dorm" && api && api !== window.location.origin) {
          url += `&apiBase=${encodeURIComponent(api)}`;
        }
        options.push({
          label: item.name,
          value: item.value,
          icon: item.icon,
          color: item.color,
          url
        });
      });

      try {
        const [dismissalRes, classesRes] = await Promise.all([
          getScreenList({ schId: this.schoolId, page: 1, intPageSize: 999 }),
          getSubDepartmentTree({ pid: this.schoolId })
        ]);

        if (dismissalRes.data.success) {
          const dismissalScreens = parseScreenListResponse(dismissalRes).slice().sort((a, b) => {
            const nameA = (a.ScreenName || "").toString();
            const nameB = (b.ScreenName || "").toString();
            return nameA.localeCompare(nameB, "zh-CN");
          });
          dismissalScreens.forEach((item) => {
            const url = `${this.baseUrl}/DismissalBigScreen?code=${item.ScreenCode}`;
            options.push({
              label: `放学大屏-${item.ScreenName}`,
              value: `dismissal:${item.ScreenCode}`,
              icon: "el-icon-monitor",
              color: "#2563eb",
              url
            });
          });
        }

        if (classesRes.data.success) {
          this.classOptions = this.extractClasses(classesRes.data.response);
          options.push({
            label: "作业公示",
            value: "homework",
            icon: "el-icon-notebook-2",
            color: "#A855F7",
            url: ""
          });
        }
      } catch (e) {
        this.$message.warning("部分大屏地址加载失败，请稍后重试");
      }

      this.screenTypeOptions = options;
      this.syncSelectionByUrl(this.form.ScreenUrl);
    },
    extractClasses(nodes) {
      const results = [];
      const traverse = (list) => {
        if (!list) {
          return;
        }
        const items = Array.isArray(list) ? list : [list];
        items.forEach((node) => {
          if (node.DeptOrgType === "class") {
            results.push({ label: node.label, value: node.value });
          }
          if (node.children && node.children.length) {
            traverse(node.children);
          }
        });
      };
      traverse(nodes);
      return results;
    },
    syncSelectionByUrl(url) {
      if (!url) {
        this.selectedScreenType = "";
        this.selectedClassId = "";
        this.selectedBuildingId = "";
        return;
      }

      const homeworkPrefix = `${this.baseUrl}/HomeWorkPage?id=`;
      if (url.startsWith(homeworkPrefix)) {
        this.selectedScreenType = "homework";
        this.selectedClassId = url.replace(homeworkPrefix, "");
        this.selectedBuildingId = "";
        this.form.ScreenUrl = url;
        return;
      }

      // 宿舍大屏：独立静态页或旧 Vue 路由
      const isDormUrl =
        url.indexOf("/static/dorm-screen/index.html?") >= 0 ||
        url.indexOf("/DormBigScreen?") >= 0 ||
        url.indexOf(`${this.baseUrl}/DormBigScreen?`) === 0;
      if (isDormUrl) {
        this.selectedScreenType = "dorm";
        this.selectedClassId = "";
        try {
          const query = url.split("?")[1] || "";
          const params = new URLSearchParams(query);
          this.selectedBuildingId = params.get("buildingId") || "";
        } catch (e) {
          this.selectedBuildingId = "";
        }
        this.form.ScreenUrl = url;
        this.loadDormBuildings();
        return;
      }

      const matched = this.screenTypeOptions.find((x) => x.url === url);
      if (matched) {
        this.selectedScreenType = matched.value;
        this.selectedBuildingId = "";
        this.form.ScreenUrl = matched.url;
        return;
      }

      this.selectedScreenType = "";
      this.selectedClassId = "";
      this.selectedBuildingId = "";
      this.form.ScreenUrl = url;
    },
    handleScreenTypeChange(value) {
      if (!value) {
        this.form.ScreenUrl = "";
        this.selectedClassId = "";
        this.selectedBuildingId = "";
        return;
      }
      if (value === "homework") {
        this.form.ScreenUrl = "";
        this.selectedBuildingId = "";
        return;
      }
      if (value === "dorm") {
        this.selectedClassId = "";
        this.selectedBuildingId = "";
        this.loadDormBuildings();
        this.updateDormUrl();
        return;
      }
      const option = this.screenTypeOptions.find((x) => x.value === value);
      this.form.ScreenUrl = option ? option.url : "";
      this.selectedClassId = "";
      this.selectedBuildingId = "";
    },
    updateHomeworkUrl() {
      if (!this.selectedClassId) {
        this.form.ScreenUrl = "";
        return;
      }
      this.form.ScreenUrl = `${this.baseUrl}/HomeWorkPage?id=${this.selectedClassId}`;
    },
    /** 宿舍大屏链接：独立静态页，楼栋可选。最后更新：2026-10-17 */
    updateDormUrl() {
      if (!this.schoolId) {
        this.form.ScreenUrl = "";
        return;
      }
      const uiBase = ((process.env.BASE_URL || "/").replace(/\/+$/, "") || "");
      let url = `${this.baseUrl}${uiBase}/static/dorm-screen/index.html?departmentId=${this.schoolId}`;
      if (this.selectedBuildingId) {
        url += `&buildingId=${this.selectedBuildingId}`;
      }
      const api = (process.env.VUE_APP_BASE_API || "").replace(/\/+$/, "");
      if (api && api !== window.location.origin) {
        url += `&apiBase=${encodeURIComponent(api)}`;
      }
      this.form.ScreenUrl = url;
    },
    async loadDormBuildings() {
      if (!this.schoolId) {
        this.dormBuildings = [];
        return;
      }
      try {
        const res = await getBuildingsListPage({
          page: 1,
          intPageSize: 500,
          departmentId: this.schoolId,
        });
        const data = res && res.data;
        const list =
          (data && data.response && (data.response.data || data.response)) ||
          (data && data.data) ||
          [];
        const arr = Array.isArray(list) ? list : [];
        this.dormBuildings = arr
          .map((b) => ({
            label: b.Name || b.BuildingName || b.name || ("楼栋" + (b.Id || b.id)),
            value: String(b.Id || b.id || ""),
          }))
          .filter((b) => b.value);
      } catch (e) {
        this.dormBuildings = [];
        console.error("加载宿舍楼栋失败", e);
      }
    },
    copyUrl(url) {
      if (!url) {
        return;
      }
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("链接已复制");
    },
    previewUrl(url) {
      if (!url) {
        return;
      }
      window.open(url, "_blank");
    },
    async publishConfig() {
      if (!this.schoolId) {
        this.$message.warning("请先在左侧选择学校");
        return;
      }
      if (!this.form.Sn) {
        this.$message.warning("请先选择 SN");
        return;
      }
      if (this.form.DisplayState === "playing") {
        const screenUrl = (this.form.ScreenUrl || "").trim();
        if (!screenUrl) {
          this.$message.warning("启用状态下大屏地址不能为空");
          return;
        }
        if (!this.isValidHttpUrl(screenUrl)) {
          this.$message.warning("大屏地址格式不合法，请输入 http/https 完整地址");
          return;
        }
        this.form.ScreenUrl = screenUrl;
      }
      const res = await publishScreenConfigAdmin(this.form);
      if (res.data.success) {
        this.$message.success(res.data.msg || "发布成功");
        this.runtime = res.data.response || {};
        this.form.DisplayState = this.runtime.DisplayState || this.form.DisplayState;
        this.form.DurationSec = Number(this.runtime.DurationSec || this.form.DurationSec || 0);
        this.form.ScreenUrl = this.runtime.ScreenUrl || this.form.ScreenUrl;
        this.syncSelectionByUrl(this.form.ScreenUrl);
      } else {
        this.$message.error(res.data.msg || "发布失败");
      }
    },
    async toggleRuntimeStatus() {
      const targetSn = (this.form.Sn || (this.runtime && this.runtime.Sn) || "").trim();
      if (!targetSn) {
        this.$message.warning("请先选择设备 SN");
        return;
      }

      const actionText = this.runtimeIsEnabled ? "禁用" : "启用";
      const nextDisplayState = this.runtimeIsEnabled ? "closed" : "playing";
      const screenUrl = ((this.runtime && this.runtime.ScreenUrl) || this.form.ScreenUrl || "").trim();
      if (nextDisplayState === "playing" && !screenUrl) {
        this.$message.warning("当前没有可用地址，无法直接启用，请先选择地址后发布");
        return;
      }

      await this.$confirm(`确认${actionText}设备 ${targetSn} 的当前生效配置吗？`, "提示", {
        type: "warning",
        confirmButtonText: `确认${actionText}`,
        cancelButtonText: "取消"
      });
      const runtimeDurationSec = this.runtime && this.runtime.DurationSec;
      const durationSec = Number(runtimeDurationSec !== null && runtimeDurationSec !== undefined ? runtimeDurationSec : this.form.DurationSec || 0);
      const res = await publishScreenConfigAdmin({
        Sn: targetSn,
        ScreenUrl: screenUrl,
        DisplayState: nextDisplayState,
        DurationSec: durationSec,
        ExtraJson: (this.runtime && this.runtime.ExtraJson) || ""
      });
      if (res.data.success) {
        this.$message.success(`${actionText}成功`);
        if (this.form.Sn === targetSn) {
          await this.loadRuntimeConfig();
        } else {
          this.runtime = res.data.response || {};
        }
      } else {
        this.$message.error(res.data.msg || `${actionText}失败`);
      }
    },
    getDisplayStateText(displayState) {
      if (!displayState) {
        return "-";
      }
      const map = {
        playing: "展示中",
        closed: "已关闭",
        cleared: "已关闭"
      };
      return map[displayState] || displayState;
    },
    getDurationText(durationSec) {
      const value = Number(durationSec || 0);
      if (value <= 0) {
        return "0 秒（不限时）";
      }
      return `${value} 秒`;
    },
    isValidHttpUrl(url) {
      try {
        const parsed = new URL(url);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
      } catch (e) {
        return false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.screen-device-page.dp-layout
  height 100%
  box-sizing border-box
  padding 12px 16px
  /* 窄屏改为上下布局，避免左侧 250px 占满横向空间导致右侧内容被挤没 */
  @media (max-width: 768px)
    flex 1
    min-height 0
    flex-direction column
    align-items stretch
    padding 12px
    .dp-left
      width 100% !important
      max-width 100%
      margin-right 0 !important
      margin-bottom 12px
      max-height 280px
      flex-shrink 0
    .dp-right
      width 100%
      min-width 0 !important
      flex 1
      min-height 0
.screen-device-page .dp-right
  display flex
  flex-direction column
  min-width 0
  min-height 0
  overflow hidden
  padding 12px 14px
.screen-device-page .dp-right > .content-wrapper
  flex 1 1 auto
  min-height 0
  height auto
  overflow-x hidden
  overflow-y auto
  display flex
  flex-direction column
  gap 10px
  width 100%
  max-width 100%
  box-sizing border-box
  scrollbar-width thin
  scrollbar-color #cbd5e1 transparent
  &::-webkit-scrollbar
    width 6px
  &::-webkit-scrollbar-thumb
    background-color #cbd5e1
    border-radius 6px
  &::-webkit-scrollbar-track
    background transparent
.config-panel
  max-width 1200px
  margin 0 auto
  width 100%
  box-sizing border-box
  @media (max-width: 768px)
    max-width 100%
    margin 0
    overflow visible
    height auto
.config-card
  flex-shrink 0
  height auto
  border-radius 8px
  border none
  box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.05)
  min-width 0
  width 100%
  box-sizing border-box
  >>> .el-card__header
    padding 10px 14px
  >>> .el-card__body
    min-width 0
    overflow-x auto
    padding 12px 14px 16px
.publish-form
  max-width 900px
  width 100%
  box-sizing border-box
  @media (max-width: 768px)
    max-width 100%
.no-data-tip
  flex 1
  display flex
  flex-direction column
  align-items center
  justify-content center
  color #c0c4cc
  i
    font-size 48px
    margin-bottom 12px
.school-tag
  margin-left 12px
  font-size 12px
  color #909399
  flex-shrink 1
  min-width 0
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.card-header
  display flex
  align-items center
  justify-content space-between
  padding 0
  min-height 0
  flex-wrap wrap
  gap 8px
  row-gap 8px
.title-wrap
  display flex
  align-items center
  flex 1
  min-width 0
  flex-wrap wrap
  gap 6px 12px
.title
  font-size 16px
  font-weight 600
  color #303133
  border-left 4px solid #2563eb
  padding-left 10px
  line-height 1.3
  flex-shrink 0
.actions
  display flex
  align-items center
  gap 8px
  min-height 32px
  flex-shrink 0

.screen-type-option
  display flex
  align-items center
  gap 8px

.screen-url-display
  display flex
  align-items center
  justify-content space-between
  gap 10px
  min-height 32px
  padding 0 10px
  border 1px solid #DCDFE6
  border-radius 4px
  background #fff
  min-width 0
  box-sizing border-box
  @media (max-width: 560px)
    flex-direction column
    align-items stretch
    padding 10px
    .url-actions
      justify-content flex-end

.url-text
  flex 1
  min-width 0
  color #606266
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.url-text-wrap
  flex 1
  min-width 0
  display flex
  align-items center
  gap 6px

.url-icon
  color #909399
  font-size 14px
  flex-shrink 0

.url-actions
  display flex
  align-items center
  gap 6px
  flex-shrink 0

.runtime-descriptions
  width 100%
  min-width 0
  >>> table.el-descriptions__table
    table-layout fixed
    width 100% !important
  >>> .el-descriptions-item__cell
    word-break break-word

.runtime-url-text
  display inline-block
  max-width 100%
  word-break break-all
  line-height 1.5
  white-space pre-wrap

.duration-help-icon
  margin-left 6px
  font-size 14px
  color #b0b8c4
  cursor help
  vertical-align middle
  &:hover
    color #2563eb

.duration-reserve-tip
  margin-top 8px
  display flex
  align-items flex-start
  gap 6px
  font-size 12px
  color #909399
  line-height 1.4
  i
    color #b0b8c4
    margin-top 1px
  span
    display inline-block
    min-width 0

.runtime-tip
  margin-top 8px
</style>

